import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { CompetitionRankingQuery } from '../types';

/**
 * typeguard for CompetitionRanking
 * @param CompetitionRankingQuery object passed to transformer
 */
export const isValidCompetitionRanking = (obj: CompetitionRankingQuery): boolean => Boolean(obj?.data?.getCompetitionRanking && !isEmptyObject(obj.data.getCompetitionRanking));
